import { InvoiceStatus, InvoiceType } from 'api/graphql-global-types';

export const mapInvoiceTypeToLabel = (type: InvoiceType): string => {
  switch (type) {
    case InvoiceType.Subscription:
      return 'Subscription';
    case InvoiceType.CbBalanceTopUp:
      return 'Balance Top-Up';
    default:
      return 'N/a';
  }
};

export const INVOICE_TYPES = [
  {
    value: InvoiceType.Subscription,
    label: mapInvoiceTypeToLabel(InvoiceType.Subscription),
  },
  {
    value: InvoiceType.CbBalanceTopUp,
    label: mapInvoiceTypeToLabel(InvoiceType.CbBalanceTopUp),
  },
];

export const mapInvoiceStatusToLabel = (status: InvoiceStatus): string => {
  switch (status) {
    case InvoiceStatus.draft:
      return 'Draft';
    case InvoiceStatus.open:
      return 'Open';
    case InvoiceStatus.paid:
      return 'Paid';
    case InvoiceStatus.uncollectible:
      return 'Uncollectible';
    case InvoiceStatus.upcoming:
      return 'Upcoming';
    case InvoiceStatus.void:
      return 'Void';
    default:
      return 'N/a';
  }
};

export const INVOICE_STATUSES = [
  {
    value: InvoiceStatus.draft,
    label: mapInvoiceStatusToLabel(InvoiceStatus.draft),
  },
  {
    value: InvoiceStatus.open,
    label: mapInvoiceStatusToLabel(InvoiceStatus.open),
  },
  {
    value: InvoiceStatus.paid,
    label: mapInvoiceStatusToLabel(InvoiceStatus.paid),
  },
  {
    value: InvoiceStatus.uncollectible,
    label: mapInvoiceStatusToLabel(InvoiceStatus.uncollectible),
  },
  {
    value: InvoiceStatus.upcoming,
    label: mapInvoiceStatusToLabel(InvoiceStatus.upcoming),
  },
  {
    value: InvoiceStatus.void,
    label: mapInvoiceStatusToLabel(InvoiceStatus.void),
  },
];

export const isInvoiceDisabled = (status: InvoiceStatus): boolean => {
  return status === InvoiceStatus.void || status === InvoiceStatus.draft;
};
